import React, { memo } from "react";

const ItalicIcon: React.FC = memo(() => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.60643 16.5C1.30084 16.5 1.04254 16.3944 0.831544 16.1832C0.620524 15.972 0.515015 15.7135 0.515015 15.4076C0.515015 15.1017 0.620524 14.8435 0.831544 14.633C1.04254 14.4224 1.30084 14.3172 1.60643 14.3172H5.1246L9.03755 2.68283H5.51938C5.21379 2.68283 4.95549 2.57723 4.74449 2.36603C4.53347 2.15483 4.42796 1.89629 4.42796 1.59042C4.42796 1.28457 4.53347 1.02636 4.74449 0.815805C4.95549 0.605268 5.21379 0.5 5.51938 0.5H14.3902C14.6958 0.5 14.9541 0.605601 15.1652 0.816802C15.3762 1.028 15.4817 1.28653 15.4817 1.59238C15.4817 1.89825 15.3762 2.15647 15.1652 2.36703C14.9541 2.57756 14.6958 2.68283 14.3902 2.68283H11.2436L7.33065 14.3172H10.4773C10.7829 14.3172 11.0412 14.4228 11.2522 14.634C11.4632 14.8452 11.5687 15.1037 11.5687 15.4096C11.5687 15.7154 11.4632 15.9736 11.2522 16.1842C11.0412 16.3947 10.7829 16.5 10.4773 16.5H1.60643Z"
        fill="currentColor"
      />
      <path
        d="M1.60643 16.5C1.30084 16.5 1.04254 16.3944 0.831544 16.1832C0.620524 15.972 0.515015 15.7135 0.515015 15.4076C0.515015 15.1017 0.620524 14.8435 0.831544 14.633C1.04254 14.4224 1.30084 14.3172 1.60643 14.3172H5.1246L9.03755 2.68283H5.51938C5.21379 2.68283 4.95549 2.57723 4.74449 2.36603C4.53347 2.15483 4.42796 1.89629 4.42796 1.59042C4.42796 1.28457 4.53347 1.02636 4.74449 0.815805C4.95549 0.605268 5.21379 0.5 5.51938 0.5H14.3902C14.6958 0.5 14.9541 0.605601 15.1652 0.816802C15.3762 1.028 15.4817 1.28653 15.4817 1.59238C15.4817 1.89825 15.3762 2.15647 15.1652 2.36703C14.9541 2.57756 14.6958 2.68283 14.3902 2.68283H11.2436L7.33065 14.3172H10.4773C10.7829 14.3172 11.0412 14.4228 11.2522 14.634C11.4632 14.8452 11.5687 15.1037 11.5687 15.4096C11.5687 15.7154 11.4632 15.9736 11.2522 16.1842C11.0412 16.3947 10.7829 16.5 10.4773 16.5H1.60643Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  );
});

export { ItalicIcon };
